import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectIsSelectedDocumentChanged = createSelector(
  [selectQbrState],
  ({ isSelectedDocumentChanged }) => isSelectedDocumentChanged
)
